import React, { useState } from 'react';
import { X, Grid, List, Filter } from 'lucide-react';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');
  const [viewMode, setViewMode] = useState('grid');

  const galleryImages = [
    {
      url: '/image/gallery/camp-06.jpg',
      title: 'Karate Camp 2026 - Group Photo',
      description: 'Students, families and instructors together between the San Kai banners at the San Kai Karate Camp, August 2026.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-05.jpg',
      title: 'Karate Camp - Outdoor Training',
      description: 'Juniors and seniors training together on the field next to the tents at the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-04.jpg',
      title: 'Karate Camp - Training Session',
      description: 'Instructors leading an outdoor session for all ages during the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-01.jpg',
      title: 'Karate Camp - Cooling Off',
      description: 'Campers relaxing and having fun in the water after training at the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-02.jpg',
      title: 'Karate Camp - By the Water',
      description: 'Children splashing about by the estuary on a break from training at the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-03.jpg',
      title: 'Karate Camp - Summer Fun',
      description: 'Cooling down with the hose on a hot summer day at the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-07.jpg',
      title: 'Karate Camp - Field Exercises',
      description: 'Campers doing press-ups and conditioning exercises on the field at the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-08.jpg',
      title: 'Karate Camp - Afternoon Session',
      description: 'Students training on the field beside the gazebo during an afternoon session at camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-09.jpg',
      title: 'Karate Camp - Learning Together',
      description: 'Instructors guiding campers of all ages through drills out in the open air.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-10.jpg',
      title: 'Karate Camp - Obstacle Course',
      description: 'Campers taking on the climbing frames of the outdoor obstacle course.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-11.jpg',
      title: 'Karate Camp - Climbing Frame',
      description: 'Testing strength and balance on the obstacle course climbing frame at camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-12.jpg',
      title: 'Karate Camp - Scaling the Net',
      description: 'Campers climbing the cargo net wall on the obstacle course.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-13.jpg',
      title: 'Karate Camp - Under Big Skies',
      description: 'Tackling the obstacle course under a dramatic summer sky.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-14.jpg',
      title: 'Karate Camp - Adventure Course',
      description: 'Exploring the full outdoor adventure course during the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/camp-15.jpg',
      title: 'Karate Camp - Woodland Walk',
      description: 'Heading off along the woodland trail during the San Kai Karate Camp.',
      category: 'camp'
    },
    {
      url: '/image/gallery/sankai-10.jpg',
      title: 'San Kai Class Photo',
      description: 'Instructors and students of all ages and grades together in the dojo after a Friday training session.',
      category: 'dojo'
    },
    {
      url: '/image/gallery/sankai-01.jpg',
      title: 'Head Kick Drill',
      description: 'A student lands a high roundhouse kick while the instructor holds a deep, low stance.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-02.jpg',
      title: 'Young Partners Kicking',
      description: 'Two young orange belts practising controlled high kicks with full protective gear.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-03.jpg',
      title: 'Partner Work',
      description: 'Juniors working in pairs on kicking techniques while the class trains in the background.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-04.jpg',
      title: 'Spinning Kick',
      description: 'A senior student in red executes a dynamic kick against the instructor during sparring practice.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-05.jpg',
      title: 'Fitness Training',
      description: 'Young students building strength with press-ups as part of the warm-up.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-06.jpg',
      title: 'Adult Sparring',
      description: 'Adult students practising kumite with gloves and footpads in the dojo.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-07.jpg',
      title: 'Kata Stance',
      description: 'A brown belt holds a strong, low stance during kata practice.',
      category: 'kata'
    },
    {
      url: '/image/gallery/sankai-08.jpg',
      title: 'Kata Focus',
      description: 'A red belt student performing kata with concentration and good posture.',
      category: 'kata'
    },
    {
      url: '/image/gallery/sankai-09.jpg',
      title: 'Yellow Belt Kata',
      description: 'A young yellow belt demonstrating a blocking technique from her kata.',
      category: 'kata'
    },
    {
      url: '/image/gallery/sankai-11.jpg',
      title: 'One-to-One Coaching',
      description: 'The instructor kneels to hold a target pad as a young student practises his kicks.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-12.jpg',
      title: 'Kicking Practice',
      description: 'Two yellow belts practising front kicks together with pink sparring gloves.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-19.jpg',
      title: 'Friday Class Line-Up',
      description: 'Students and instructors lined up and ready at the start of a Friday training session.',
      category: 'dojo'
    },
    {
      url: '/image/gallery/sankai-14.jpg',
      title: 'Instructor Demonstration',
      description: 'The instructor demonstrates a high kick for young students to learn from.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-13.jpg',
      title: 'Junior Kicking Drill',
      description: 'A young student practises a controlled kick with his partner during pair work.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-16.jpg',
      title: 'Kicking at the Senior',
      description: 'A junior student aims a kick at a senior student in red during partner practice.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-18.jpg',
      title: 'Junior vs Senior Sparring',
      description: 'A young student squares up to an older black belt in a friendly sparring drill.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-15.jpg',
      title: 'Kneeling Target Drill',
      description: 'One student kneels while her partner practises a high kick with precision and control.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-17.jpg',
      title: 'Partner Kicking Practice',
      description: 'Two red belts working together on kicking accuracy and balance.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-20.jpg',
      title: 'Yellow Belt Kick',
      description: 'A yellow belt shows a strong side kick as her partner looks on.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-21.jpg',
      title: 'Watchful Instruction',
      description: 'The instructor keeps a close eye as two girls practise kicks together.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-22.jpg',
      title: 'Pink Gloves Partner Work',
      description: 'Two yellow belts practise kicks and punches with an instructor guiding them.',
      category: 'kumite'
    },
    {
      url: '/image/gallery/sankai-23.jpg',
      title: 'Kick and Counter',
      description: 'A red belt delivers a kick while her partner prepares to counter under instructor supervision.',
      category: 'training'
    },
    {
      url: '/image/gallery/sankai-24.jpg',
      title: 'Seniors Sparring',
      description: 'Senior students practising high kicks during kumite training.',
      category: 'kumite'
    },

    {
      url: 'https://iili.io/qaQp0u4.jpg',
      title: 'Grading Ceremony Success',
      description: 'Proud students displaying their newly earned certificates alongside their dedicated instructors after a successful grading.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/npd4ls2a_518338915_10162664268985469_642790059381780905_n.jpg',
      title: 'San Kai Outdoor Gathering',
      description: 'Black belt instructors and students proudly displaying the San Kai Karate Association banners at an outdoor event.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/jr5ab9h8_518367550_10162664270445469_6991178459620346749_n.jpg',
      title: 'Grading Success',
      description: 'Proud students and instructors celebrating achievement with certificates after a successful belt grading ceremony.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/ywwtshb3_541282368_10162932601145469_8353107557025832179_n.jpg',
      title: 'Outdoor Training',
      description: 'Student demonstrating strong technique and focus during outdoor training in nature.',
      category: 'training'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/osq6h69n_554504396_25341197225483508_7465774037354839022_n.jpg',
      title: 'Class in Action',
      description: 'Mixed age group practicing synchronized striking techniques together in the dojo.',
      category: 'training'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/qrz5kwkt_554740250_25341197648816799_1952776998398133644_n.jpg',
      title: 'Dedicated Instruction',
      description: 'Instructor leading students through fundamental karate techniques during a training session.',
      category: 'training'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/ora4nxjf_462752597_9156801621016326_8897428445823476679_n.jpg',
      title: 'Instructor Leading Youth Class',
      description: 'San Kai instructor guiding young students through stance practice in the community hall.',
      category: 'training'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/nqfhqqlo_471840880_9623309737698843_3549714354091294368_n.jpg',
      title: 'Sparring Practice',
      description: 'Black belt instructor engaging in controlled sparring practice with a young student wearing protective gear.',
      category: 'kumite'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/mkkasgjx_515378824_10162635268825469_2611607286928395237_n.jpg',
      title: 'Competition Champions',
      description: 'Three proud winners displaying their trophies and medals after a successful tournament performance.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/1xa2x2m2_516840258_10162664268310469_5170304700623412253_n.jpg',
      title: 'Summer Camp Training',
      description: 'Students and instructors participating in outdoor training during the annual San Kai summer camp.',
      category: 'camp'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/ltg0yph2_130082821_4012353585461181_354434190797696033_n.jpg',
      title: 'Tournament Podium',
      description: 'Young karateka celebrating their achievements on the podium after a competitive tournament.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/qbtr4u16_481572126_122099432798792268_6719706477096884187_n.jpg',
      title: 'Dojo Family Portrait',
      description: 'The San Kai family - instructors, students, and young karateka of all ages gathered together in the dojo.',
      category: 'dojo'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/iouybotq_481661878_122094062858792268_5322832741084613784_n.jpg',
      title: 'Karate Community',
      description: 'Large group photo showcasing our diverse and inclusive karate community with students and instructors of all belt levels.',
      category: 'dojo'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/xnykeafw_485781980_122117756720792268_9200979904331782330_n.jpg',
      title: 'Young Champions Celebrate',
      description: 'Two excited young competitors proudly displaying their competition medals with big smiles.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/78mifz4w_485932113_122117756582792268_8426980488975356258_n.jpg',
      title: 'Competition Team Success',
      description: 'San Kai competition team with coaches, officials, and young champions showing off their hard-earned trophies and medals.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/87bzjl5c_486032424_122117758142792268_5748747782906444122_n.jpg',
      title: 'Proud Medal Winners',
      description: 'Instructor celebrating with two young students who earned medals at a karate tournament.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/4ntdm2gw_92997717_10157835288660469_2869375909956157440_n.jpg',
      title: 'Dynamic Sparring Practice',
      description: 'Advanced students practicing high kicks and defensive techniques with protective gear in the training space.',
      category: 'kumite'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/meymx8ut_468839704_9491286937567791_4117754607050033691_n.jpg',
      title: 'Kyu Rank Achievement',
      description: 'Students proudly displaying their San Kai Karate Association certificates after successful kyu rank examination.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/77kg1m0r_517150635_10162664266455469_8657447416904001681_n.jpg',
      title: 'Dan Rank Presentation',
      description: 'Senior instructor presenting Dan rank certificate to accomplished black belt practitioner in formal ceremony.',
      category: 'events'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/suzs8wrx_517391152_24700246059578156_8476221390068086265_n.jpg',
      title: 'Youth Tournament Match',
      description: 'Young competitors engaged in an exciting kumite match under the watchful eyes of certified referees.',
      category: 'kumite'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Photos' },
    { id: 'training', label: 'Training' },
    { id: 'kata', label: 'Kata' },
    { id: 'kumite', label: 'Kumite' },
    { id: 'events', label: 'Events' },
    { id: 'camp', label: 'Karate Camp' },
    { id: 'dojo', label: 'Dojo' }
  ];

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="page-wrapper gallery-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Training Gallery</h1>
          <p className="page-subtitle">
            Explore moments from our dojo - training sessions, achievements, and our passionate karate community.
          </p>
        </div>
      </div>

      <div className="container">
        {/* Filter Controls */}
        <div className="gallery-controls">
          <div className="gallery-filters">
            <Filter size={20} />
            <span className="filter-label">Filter:</span>
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`filter-btn ${filter === cat.id ? 'active' : ''}`}
                onClick={() => setFilter(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
          <div className="view-toggle">
            <button
              className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              <Grid size={20} />
            </button>
            <button
              className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <List size={20} />
            </button>
          </div>
        </div>

        {filter === 'camp' && (
          <div
            data-testid="camp-info"
            style={{ borderLeft: '4px solid #d32f2f', background: '#f8f8f8', padding: '1.25rem 1.5rem', borderRadius: '8px', margin: '0 0 2rem' }}
          >
            <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem', fontWeight: 700 }}>San Kai Karate Camp</h3>
            <p style={{ margin: 0, lineHeight: 1.6, color: '#444' }}>
              Every summer San Kai members, families and instructors head outdoors for our Karate Camp - full of
              open-air training, camping, an obstacle course, woodland walks and fun together. These photos are from our latest camp in August 2026.
            </p>
          </div>
        )}


        {/* Gallery Grid */}
        <div className={`gallery-grid ${viewMode === 'list' ? 'list-view' : ''}`}>
          {filteredImages.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => openLightbox(image)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img 
                src={image.url} 
                alt={image.title} 
                className="gallery-image"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <div className="gallery-category">{image.category}</div>
                <h3 className="gallery-title">{image.title}</h3>
                <p className="gallery-description">{image.description}</p>
              </div>
            </div>
          ))}
        </div>

        {filteredImages.length === 0 && (
          <div className="no-results">
            <p>No images found in this category.</p>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.url} 
              alt={selectedImage.title} 
              className="lightbox-image"
            />
            <div className="lightbox-info">
              <span className="lightbox-category">{selectedImage.category}</span>
              <h3 className="lightbox-title">{selectedImage.title}</h3>
              <p className="lightbox-description">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;